import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthenticationServiceService} from '../service/authentication-service.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-authentication-form',
  templateUrl: './authentication-form.component.html',
  styleUrls: ['./authentication-form.component.css']
})
export class AuthenticationFormComponent implements OnInit {
  authDetailForm: FormGroup;
  loading: boolean;
  submitted: boolean;

  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private authenticationService: AuthenticationServiceService,
              private toastr: ToastrService) {
    this.authDetailForm = this._formBuilder.group({
      macAddress: ['', Validators.required],
      testAuthenticationData: ['', Validators.required]
    });
  }

  ngOnInit() {
  }

  saveAuth(authDetailsForm) {
    const macAddress = this.authDetailForm.value.macAddress;
    const testAuthenticationData = this.authDetailForm.value.testAuthenticationData;
    this.authenticationService.addAuthentication(macAddress, testAuthenticationData)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Auth Details saved successfully');
            this.router.navigate(['/elasticcare/authentications']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });
  }
}
